import { css } from 'lit';

export default css`
  :host {
    display: grid;
    grid-template-columns: 35rem 1fr;
    --header-height: var(--maxH, 100%);
  }
  
  :host(.new-landing-page) {
    display: block;
    overflow-y: auto;
  }
  
  :host(.layout-content) {
    grid-template-columns: min(15vw,35rem) 1fr min(15vw,35rem);
  }

  lh-header {
    width: 400px;
  }

  ::slotted(:not(lh-questionnaire):not(lh-header)) {
    grid-column: span 2;
  }

  :host([data-device='desktop'][current-section='S_Summary_Details']) {
    grid-template-columns: 1fr;
  }
  :host([data-device='desktop'][current-section='S_Summary_Details'])
    ::slotted(lh-header) {
    display: none;
  }

  ::slotted(lh-questionnaire[current-section="S_Summary_Details"]) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }  


  :host([data-device='desktop'][current-section='S_MTA_Coverages']) {
    grid-template-columns: 1fr;
  }
  :host([data-device='desktop'][current-section='S_MTA_Coverages'])
    ::slotted(lh-header) {
    display: none;
  }

  ::slotted(lh-questionnaire[current-section="S_MTA_Coverages"]) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  /* Additional Insured MTA: full-width scrollable content, no left progress column */
  :host(.layout-content.additional-insured-mta) {
    grid-template-columns: 1fr;
    align-content: start;
    height: auto;
    min-height: 100%;
    max-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
  }

  :host(.layout-content.additional-insured-mta) ::slotted(lh-header) {
    display: none;
  }

  :host(.layout-content.additional-insured-mta) ::slotted(lh-additional-insured-mta-screen) {
    grid-column: 1;
    width: min(100%, 110rem);
    max-width: 110rem;
    justify-self: center;
    position: relative;
    z-index: 0;
  }
`;
